import { render, staticRenderFns } from "./FilterMarketTabs.vue?vue&type=template&id=1ba04f69&scoped=true&"
import script from "./FilterMarketTabs.vue?vue&type=script&lang=js&"
export * from "./FilterMarketTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba04f69",
  null
  
)

export default component.exports